import React from 'react';
import { Link } from 'react-router-dom';

import './NoMatch.css';

export default ({ location }) => (
  <div className="no-match">
    <h2>404</h2>
    <p>No page for {location.pathname}</p>
    <p><Link to="/" className="hash-link">Go back</Link></p>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/NoMatch.js